var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.label))]),_c('v-slider',{attrs:{"min":0,"max":100,"value":_vm.value},on:{"input":function($event){_vm.$emit('input', Number($event))}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }